module.exports = __webpack_public_path__ + "static/media/item_14_6_comp.bd1d95fd.png";